import React from 'react'
import { Route } from 'react-router-dom'
import { IndexReport, ReportCreate, ReportEdit, ReportMain, ReportView } from '../Views/Web/Report/Index'

function ReportRoutes() {
    return (
      <Route path="report" element={<ReportMain />}>
           <Route index element={<IndexReport/>} />
           <Route path='create' element={<ReportCreate/>} />
           <Route path='edit/:reportEditId' element={<ReportEdit/>} />
           <Route path='view/:reportViewId' element={<ReportView/>} />
         
          
      </Route>
    )
  }
  
  export default ReportRoutes